export default [{
                              fontFamily: 'AveriaSansLibre-Bold',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/AveriaSansLibre-Bold.ttf'),
                          },{
                              fontFamily: 'BrandonGrotesque-Bold',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/BrandonGrotesque-Bold.ttf'),
                          },{
                              fontFamily: 'FontAwesome',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/FontAwesome.ttf'),
                          },{
                              fontFamily: 'FontAwesome5_Brands',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/FontAwesome5_Brands.ttf'),
                          },{
                              fontFamily: 'FontAwesome5_Regular',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/FontAwesome5_Regular.ttf'),
                          },{
                              fontFamily: 'FontAwesome5_Solid',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/FontAwesome5_Solid.ttf'),
                          },{
                              fontFamily: 'Ionicons',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/Ionicons.ttf'),
                          },{
                              fontFamily: 'Montserrat-Bold',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/Montserrat-Bold.ttf'),
                          },{
                              fontFamily: 'OpenSans-Bold',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/OpenSans-Bold.ttf'),
                          },{
                              fontFamily: 'OpenSans-Light',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/OpenSans-Light.ttf'),
                          },{
                              fontFamily: 'OpenSans-Regular',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/OpenSans-Regular.ttf'),
                          },{
                              fontFamily: 'OpenSans-SemiBold',
                              file: require('/Users/robertarissen/Dev/connected-tv-apps-main/appConfigs/base/fonts/OpenSans-SemiBold.ttf'),
                          },];